import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import './Contact.css';

function Contact() {
    return (
        <section id="contact" className="contact-section">
            <Container>
                <div className="section-header">
                    <h2>Contact</h2>
                    <div className="underline"></div>
                </div>

                <Row className="contact-content">
                    <Col lg={6} className="contact-info">
                        <div className="info-card">
                            <FontAwesomeIcon icon={faLocationDot} className="info-icon" />
                            <h3>Adresa Noastră</h3>
                            <p>Str. Regimentului 22 C</p>
                            <p>Curtea De Arges, Judeţ Arges</p>
                        </div>

                        <div className="info-card">
                            <FontAwesomeIcon icon={faPhone} className="info-icon" />
                            <h3>Telefon</h3>
                            <a href="tel:+40744 626 685">+40 744 626 685</a>
                        </div>

                        <div className="info-card">
                            <FontAwesomeIcon icon={faEnvelope} className="info-icon" />
                            <h3>Email</h3>
                            <a href="mailto:ionel.tache68@yahoo.com">ionel.tache68@yahoo.com</a>
                        </div>
                    </Col>

                    <Col lg={6} className="map-container">
                        <div className="map-wrapper">
                            <iframe
                                title="Locația noastră"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2830.933006795334!2d24.669439776891714!3d45.13774025708439!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b2f0d9c20d7bed%3A0x8d6ad6cca7f27f96!2sStrada%20Regimentului%2022%20C%2C%20Curtea%20de%20Arge%C8%99%20115300!5e0!3m2!1sen!2sro!4v1709728391234!5m2!1sen!2sro"
                                width="600"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Contact;